import React, { useEffect, useState } from "react";
import { sortObjectsByAlphabet } from "../utils";
import * as deviceService from "../devices/deviceService";
import SelectV2 from "../view/SelectV2";

function ChooseDeviceField({ deviceId, setDeviceId, className = "", selectClassName = "", labelClassName = "" }) {

    const [devices, setDevices] = useState([]);

    useEffect(() => {
        const loadDevices = async () => {
            const devicesList = await deviceService.getAllDevices();
            if (devicesList && Array.isArray(devicesList) && devicesList.length) {
                setDevices(devicesList);
            }
        }
        loadDevices();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [])

    const onChange = (id) => {
        setDeviceId(id);
    }

    const devicesCopy = sortObjectsByAlphabet(devices, 'hostName');
    const options = [
        { value: "0", label: "Choose" },
        ...((devicesCopy || []).map((device) => ({ value: String(device.id), label: device.hostName })))
    ];


    return (
        <div className={className || "oct_form-group-top"}>
            <label htmlFor="deviceName" className={labelClassName}>Choose Device
                {/* <span className="text-danger">*</span> */}
            </label>
            <SelectV2
                inputId="deviceName"
                className={selectClassName}
                value={String(deviceId || 0)}
                onChange={onChange}
                options={options}
                noOptionsMessage={() => "No devices available"}
            />
        </div>
    );
}

export default ChooseDeviceField;
